export const GET_ROOMS_ACTION = 'GET_ROOMS_ACTION'

export const getRoomsAction = (callback) => ({
  type: GET_ROOMS_ACTION,
  callback,
})
